/** Desk workspace status line (#84, #91): null for anything that is not a Desk integration. */
export function deskWorkspaceNote(i: {
  kind: string;
  deskWorkspaceVerified?: boolean;
  deskTenantIdSource?: string;
}): string | null {
  if (i.kind !== 'desk') return null;
  if (i.deskWorkspaceVerified) return 'Workspace verified.';
  const confirmed = 'It is confirmed the first time Desk accepts an alert from this integration.';
  // Anything the directory did not match (including older records) is stored as typed.
  return i.deskTenantIdSource === 'directory-domain' || i.deskTenantIdSource === 'directory-slug'
    ? `Workspace found, not yet verified. ${confirmed}`
    : `We couldn't match this to a Desk workspace yet. ${confirmed}`;
}
